<template>
  <div class="iVideoBlock">
    <div class="iVideoWrap">
      <div class="dimTemporarilyCome" v-if="videos.length == 0">{{ $t('MSG.COMING') }}</div>
      <div class="iVideoBox slide" v-else v-for="video in videos.slice(0, 3)" :key="video.url">
        <a class="fancybox-media" :href="getVideosLink(video.url)" data-fancybox="gallery">
          <div class="view"></div>
          <div class="youTubeImg">
            <img :src="getVideosImg(video.url)">
          </div>
        </a>
      </div>

    </div>
  </div>
</template>

<style>
@import "@fancyapps/ui/dist/fancybox.css";
</style>

<script>
import fancyBoxMixin from '@/mixins/fancyBoxMixin' // 載入 fancyBoxMixin
export default {
  mixins: [fancyBoxMixin], // 載入 fancyBoxMixin
  data () {
    return {
      videos: []
    }
  },
  methods: {
    getVideosLink (url) {
      return `https://youtu.be/${url}`
    },
    getVideosImg (url) {
      return `https://img.youtube.com/vi/${url}/0.jpg`
    }
  },
  created () {
    fetch('./videos.json')
      .then(rs => rs.json())
      .then(rs => {
        // console.log(rs)
        return this.videos = rs
      })
  }
}
</script>
